import { useState, useRef } from "react";
import { Button } from "@mui/material";
import { Grid } from "@mui/material";
import { ApiGateway } from '../config/config'
import { getToken } from '../auth/auth'
import axios from 'axios'

export default function UploadFile(props = {}) {
  const [filename, setFilename] = useState("No file chosen");
  const [csvData, setCsvData] = useState("");

  const fileInputRef = useRef(null);

  const normalizeFilenameForUpload = (name = '') => {
    const value = String(name ?? '')
    return value.length ? value : 'upload.csv'
  }

  const normalizeFilenameForApi = (name = '') => {
    const raw = String(name ?? '')
      .replace(/^\uFEFF/, '')
      .replace(/[\u0000-\u001f\u007f]/g, '')
      .trim()

    const dotIndex = raw.lastIndexOf('.')
    const base = dotIndex > 0 ? raw.slice(0, dotIndex) : raw
    const ext = dotIndex > 0 ? raw.slice(dotIndex + 1) : 'csv'

    const sanitizedBase = base
      .replace(/[^a-zA-Z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .replace(/_+/g, '_')

    const normalizedBase = sanitizedBase || 'upload'
    const safeBase = /^[a-zA-Z]/.test(normalizedBase)
      ? normalizedBase
      : `upload_${normalizedBase}`

    const safeExt = String(ext || 'csv')
      .replace(/[^a-zA-Z0-9]/g, '')
      .toLowerCase() || 'csv'

    return `${safeBase}.${safeExt}`
  }

  const hasCsvDataRows = (csv = '') => {
    const lines = String(csv)
      .replace(/^\uFEFF/, '')
      .replace(/\r\n?/g, '\n')
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean)

    if (lines.length <= 1) return false

    return lines.slice(1).some((line) => line.split(',').some((cell) => cell.trim() !== ''))
  }

  const reset = () => {
    setFilename("No file chosen")
    fileInputRef.current.value = ""
    setCsvData("")
  }

  const fallbackNoResults = () => {
    props.setResults([])
    reset()
  }

  const handleFileSelection = (e) => {
    if (!e.target.files) {
      return;
    }
    const file = e.target.files[0];
    if (!file) {
      fallbackNoResults()
      return
    }

    const uploadFilename = normalizeFilenameForUpload(file.name)
    setFilename(uploadFilename);

    const reader = new FileReader();
    reader.onerror = () => {
      fallbackNoResults()
    }
    reader.onload = (evt) => {
      if (typeof evt?.target?.result !== 'string') {
        fallbackNoResults()
        return;
      }

      const normalized = evt.target.result.replace(/^\uFEFF/, '')
      setCsvData(normalized)
      onUpload(uploadFilename, normalized)
    };
    reader.readAsText(file);

  };

  const onUpload = async (filename, csvData) => {
    const safeFilename = normalizeFilenameForApi(filename)
    const basePath = `${ApiGateway.user}/parse-csv`

    const { accessToken, idToken } = await getToken()
    try {
      props.startLoading()
      console.log(`Uploading file: ${safeFilename}`)
      console.log(`CSV Data: ${csvData}`)
      if (!hasCsvDataRows(csvData)) {
        await axios.post(basePath, {
          filename: safeFilename,
          csvData: '',
          accessToken,
          noData: true,
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
          }
        })
        props.setResults([])
      }
      else {
        const res = await axios.post(basePath, {
          filename: safeFilename,
          csvData,
          accessToken
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
          }
        })
        props.setResults(Array.isArray(res?.data) ? res.data : [])
      }
    } catch (error) {
      console.error(error)
      props.setResults([])
    } finally {
      props.stopLoading()
    }
    reset()
  }

  const onChooseFile = () => {
    fileInputRef.current.click()
  }

  return (
      <Grid item xs={12} md={12}>
        <Button variant="outlined" onClick={onChooseFile}>Upload User File</Button>
        <input ref={fileInputRef} style={{ display: 'none' }} type="file" onChange={handleFileSelection} />
      </Grid>
  );
}